import { css } from '@emotion/react';

import { useMobileWebConversationalDiscoveryExperiment } from 'bundles/unified-common/contexts/MobileWebConversationalDiscoveryExperimentContext';

const gapStyle = css`
  gap: 6px;
`;

/**
 * Uniform 6px gap between the mobile nav's right-hand icon-row items in the mobile-web
 * conversational-discovery treatment (MERCH-3449); no-op everywhere else.
 */
const useMobileNavIconRowGapStyle = () => {
  const { mobileWebConversationalDiscoveryEnabled } = useMobileWebConversationalDiscoveryExperiment();
  return mobileWebConversationalDiscoveryEnabled ? gapStyle : undefined;
};

export default useMobileNavIconRowGapStyle;
